import type { Dispatch, SetStateAction } from 'react'
import type { BdrLead, BdrCloser } from '@/types'
import { useBdrPanelModalState } from '@/hooks/bdrPanel/useBdrPanelModalState'
import { useBdrPanelLeadMutations } from '@/hooks/bdrPanel/useBdrPanelLeadMutations'
import { useBdrPanelPendencias } from '@/hooks/bdrPanel/useBdrPanelPendencias'

export type UseBdrPanelActionsParams = {
  currentBdrId: string
  viewTab: string
  closers: BdrCloser[]
  setLeadsList: Dispatch<SetStateAction<BdrLead[]>>
  setQueueLeads: Dispatch<SetStateAction<BdrLead[]>>
  fetchTodayQueue: () => Promise<void>
  fetchAllLeads: (p?: number, append?: boolean) => Promise<void>
  fetchBankLeads: (p?: number) => Promise<void>
}

export function useBdrPanelActions({
  currentBdrId,
  viewTab,
  closers,
  setLeadsList,
  setQueueLeads,
  fetchTodayQueue,
  fetchAllLeads,
  fetchBankLeads,
}: UseBdrPanelActionsParams) {
  const modal = useBdrPanelModalState()

  const mutations = useBdrPanelLeadMutations({
    currentBdrId,
    viewTab,
    closers,
    selectedLead: modal.selectedLead,
    newLead: modal.newLead,
    regTentativa: modal.regTentativa,
    setSelectedLead: modal.setSelectedLead,
    setIsEditing: modal.setIsEditing,
    setBackendErrors: modal.setBackendErrors,
    setShowRegTentativa: modal.setShowRegTentativa,
    setSavingTentativa: modal.setSavingTentativa,
    setRegTentativa: modal.setRegTentativa,
    setLeadsList,
    setQueueLeads,
    handleCloseModal: modal.handleCloseModal,
    fetchTodayQueue,
    fetchAllLeads,
    fetchBankLeads,
  })

  const pendencias = useBdrPanelPendencias(modal.selectedLead, modal.setSelectedLead)

  return {
    formRef: modal.formRef,
    showModal: modal.showModal,
    handleCloseModal: modal.handleCloseModal,
    handleOpenNewLead: modal.handleOpenNewLead,
    handleOpenLeadDetail: modal.handleOpenLeadDetail,
    selectedLead: modal.selectedLead,
    setSelectedLead: modal.setSelectedLead,
    isNewLead: modal.isNewLead,
    setIsNewLead: modal.setIsNewLead,
    isEditing: modal.isEditing,
    setIsEditing: modal.setIsEditing,
    showRegTentativa: modal.showRegTentativa,
    setShowRegTentativa: modal.setShowRegTentativa,
    savingTentativa: modal.savingTentativa,
    setSavingTentativa: modal.setSavingTentativa,
    newLead: modal.newLead,
    setNewLead: modal.setNewLead,
    regTentativa: modal.regTentativa,
    setRegTentativa: modal.setRegTentativa,
    backendErrors: modal.backendErrors,
    setBackendErrors: modal.setBackendErrors,
    handleStartEdit: modal.handleStartEdit,
    ...mutations,
    ...pendencias,
  }
}
